module.exports = __webpack_public_path__ + "img/unsign2.60879c11.svg";